import React from 'react'
export const brands = [

];
export default function Brands() {
    return (
        <div className="flex flex-row w-full h-full my-1 p-1 justify-evenly">
            {brands.map(p => {
                return <img
                className='w-24'
                key={p.id}
                src={p.src} alt="can't show brandlogo"
                onError={(e) => {
                    e.currentTarget.onerror = null; // prevents looping
                    e.currentTarget.src = "noImage.jpg";
                  }}
                 />;
            })}
        </div>
    )
}
